<template>
  <div v-if="allowed">
    <div class="form-group m-form__group row">
      <label class="col-form-label col-lg-3 col-sm-12"
        >{{ labels["add_files"] }} &nbsp;:</label
      >
      <div class="col-lg-4 col-md-9 col-sm-12">
        <div
          class="m-dropzone dropzone m-dropzone--primary"
          :id="idElem"
          action="/"
        >
          <div class="m-dropzone__msg dz-message needsclick">
            <h3 class="m-dropzone__msg-title">
              {{ labels["drop_files_to_upload"] }}
            </h3>
            <span class="m-dropzone__msg-desc"
              >10 {{ labels["files_upload_limit"] }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Dropzone from 'dropzone';
import { firebase, firestoreDB, storage } from '../../assets/js/firebase';

export default {
  name: 'MultiUploadFile',
  /**
   * type can be 'projects', 'themes' etc
   * objectId is the id of the object concerned by the upload
   */
  props: ['type', 'objectId'],
  data() {
    return {
      allowed: false,
      idElem: null,
    };
  },
  computed: {
    ...mapState({
      labels: (state) => state.labels,
    }),
  },
  methods: {
    startUploading(file) {
      const my = this;
      console.log('startUploading', file);
      const ext = file.name.substr(file.name.lastIndexOf('.') + 1);
      const fileName = `${file.upload.uuid}.${ext}`;
      const storagePath = `uploaded-files/${this.type}/${this.objectId}/${fileName}`;
      const myFileRef = storage.ref(storagePath);

      myFileRef.put(file).then((snapshot) => {
        snapshot.ref.getDownloadURL().then((downloadURL) => {
          console.log('File available at', downloadURL);
          my.saveFileIntoFirestore(storagePath, file.name, downloadURL);
          my.myDropzoneFiles.removeFile(file);
        });
      });
    },
    saveFileIntoFirestore(storagePath, name, downloadURL) {
      try {
        firestoreDB
          .collection(`files-${process.env.ENV_SHORTNAME}`)
          .doc()
          .set({
            name: String(name),
            publicPath: String(downloadURL),
            path: String(storagePath),
            type: String(this.type),
            resourceId: String(this.objectId),
            date: firebase.firestore.Timestamp.fromDate(new Date()),
          });

        console.log('file saved in DB');
      } catch (error) {
        console.error('ERROR:', error);
      }
    },
  },
  mounted() {
    if (this.allowed) {
      const my = this;
      this.myDropzoneFiles = new Dropzone(`#${this.idElem}`, {
        paramName: 'file', // The name that will be used to transfer the file
        maxFiles: 10,
        maxFilesize: 10, // MB
        addRemoveLinks: true,
        // acceptedFiles: '*',
        autoProcessQueue: false,
        accept(file, done) {
          console.log('accept', file);
          if (true) {
            my.startUploading(file);
            done();
          }
        },
      });
    }
  },
  created() {
    const allowedType = [
      'brands',
      'products',
      'ingredients',
      'patents',
      'themes',
      'collections',
      'product_ingredients',
    ];
    if (allowedType.indexOf(this.type) !== -1) {
      this.allowed = true;
    }

    this.idElem = `m-dropzone-files_${Math.floor(
      Math.random() * Math.floor(1000),
    )}`;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Upload/MultiUploadFile.vue